import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import getPedidosPedidosAutorizaciones from '../../../utils/getPedidosPedidosAutorizaciones';
import { FadeLoader } from 'react-spinners';
import moment from 'moment';
import _ from 'lodash';
import PedidoDetalle from './PedidoDetalle';
import {fetchSolicitudesFacturacion } from '../../../actions';
const blurRow = (numProforma, numPedidoVeh, codCia, codProv,nurFichaVtaPedido, f) => {
  if (document.getElementById(numPedidoVeh).className === 'prueba collapse in') {
    document.getElementById(numPedidoVeh).className = 'prueba collapse';
  } else {
    //document.querySelectorAll('.prueba.collapse.in').forEach(div => div.classList.remove('in'));
    for(var i=0;i<document.querySelectorAll('.prueba.collapse.in').length;i++){
      document.querySelectorAll('.prueba.collapse.in')[i].classList.remove('in');
    }
    document.getElementById(numPedidoVeh).className = 'prueba collapse in';
    f(numProforma, numPedidoVeh, codCia, codProv,nurFichaVtaPedido);
  }
};

const LiComponent = (props) => {

  let valores = props.valores;
  valores.unshift({
    indReqAutHito:props.valores[0].indReqAutHito,
    indActRealizada:props.valores[0].indActRealizada,
    desAutFichaVta:props.valores[0].desHitoFive,
  });

  const listItems = valores.map((row, i) =>
    <li key={i}  >

      { i!==0 && row.nomAut !==null ?(
            <div className='tooltip'>
                    <div> {row.codAutFichaVta=='34'?'Lugar de Entrega: ':'Ejecutado por: ' }
                    {row.nomAut + ' - ' + moment(row.fecUsuarioAut).format('DD/MM/YYYY')}
                    </div>
            </div>):null}

      <i
        className={`skewList-list-icon
        ${(i === 0) ? ('ion-checkmark-circled') : (row.indReqAutHito === 'S' ? 'ion-checkmark':'ion-person-stalker')}
        ${(i === 0) ? (props.primeroEsVerde ===1 ? 'c-green' : props.primeroEsVerde===2?'c-yellow':'c-gray-1') : (row.indActRealizada === 'S' ? 'c-green' : 'c-gray-1')}`}
      />
      <div className='skewList-text'>
        <p><span className={`${i === 0 ? 'bold' : ''}`}>{_.capitalize(row.desAutFichaVta)}</span></p>
      </div>
    </li>

  );
  return listItems;
};

const UlComponent = (props) => {

  const listItems = props.valores.map((row, i) =>

    <ul key={i} className='skewList-group' >
      <LiComponent
      valores={row} primeroEsVerde={_.size(row) === _.size(row.filter((x, i) => x.indActRealizada === 'S' ))?1:_.size(row) > _.size(row.filter((x, i) => x.indActRealizada === 'S' )) && _.size(row.filter((x, i) => x.indActRealizada === 'S' ))>0 ?2:0} />
    </ul>
  );
  return listItems;
};

const AutorizacionesHorizontal = (props) => {

  let autorizaciones = props.autorizaciones
  if (_.isArray(autorizaciones)) {
    autorizaciones = _.sortBy(autorizaciones, ['numOrdenHito','numOrdenAct']);
    autorizaciones = _.groupBy(autorizaciones, 'codHitoFive');
    autorizaciones = _.toArray(autorizaciones);
    return <UlComponent valores={autorizaciones} />;
  }
  return null;
};

const TablePedidos = props => (
  <div>
    <table className={'table table-hover table-accordion'}>
      <thead className='table-head'>
        <tr>
          <th>
            <div className='checkbox checkbox-inline'>
              <label>
                <input type='checkbox' id={'checkBoxAll'} onClick={() => props.selectAll()} />
                <div className='checkbox-skin' />
              </label>
            </div>
          </th>
          <th>Nº Pedido</th>
          <th>Estado</th>
          <th>Nº Chasis</th>
          <th>Año</th>
          <th>Color</th>
          <th>Situación</th>
          <th>Ubicación</th>
          <th>SKU</th>
          <th/>
        </tr>
      </thead>
      {
        props.pedidos.length>0?(
          props.pedidos.map((data, i) =>
          <tbody key={data.numPedidoVeh}>
            <tr >
              <td>
                <div className='checkbox checkbox-inline'>
                  <label htmlFor={`${data.numPedidoVeh}-pedidos`}>
                    <input
                      type='checkbox'
                      checked={props.pedidosConCheck.indexOf(data.numPedidoVeh)>=0}
                      onChange={() => props.selectCheckPedidos(data.numPedidoVeh)}
                      id={`${data.numPedidoVeh}-pedidos`}
                    />
                    <div className='checkbox-skin' />
                  </label>
                </div>
              </td>
              <td><button className='btn btn-iconLeft btn-link' data-dismiss='modal' data-toggle='modal' data-target='#fdv-detalle'  onClick={() => props.fnSelectPedido(data.numPedidoVeh)} ><i/><span>{data.numPedidoVeh}</span></button></td>
              <td><span className='pill pill-block pill-yellow'>{data.estadoPedido}</span></td>
              <td>{data.numChasis}</td>
              <td>{data.anoFabricacionVeh}</td>
              <td>{data.desColorVeh}</td>
              <td>{data.desSituPedido}</td>
              <td>{data.desUbicaPedidoVeh}</td>
              <td>{data.sku}</td>
              <td onClick={() => blurRow(data.numProfVeh, data.numPedidoVeh, data.codCia, data.codProv,data.nurFichaVtaPedido , props.getPedidosPedidosAutorizaciones)}/>
            </tr>
            <tr className='table-extra'>
              <td colSpan='9'>
                <div className='prueba collapse' id={data.numPedidoVeh}>
                  <div className='table-extra-wrap'>
                    <div className='skewList'>
                      <AutorizacionesHorizontal autorizaciones={props.pedidosAutorizaciones}  />
                    </div>
                    <button className='btn btn-iconRight btn-link pull-right' data-dismiss='modal' data-toggle='modal'  onClick={props.openModal} ><span>Ver detalle de pedidos</span><i className='ion-chevron-right' /></button>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
          )):(
            <tbody key='0'>
            <tr >
            <td colSpan='9'><p style={{'text-align':'center'}}> No existe registros !!</p> </td>
            </tr>
            </tbody>
          )

            }
    </table>
  </div>
);

TablePedidos.defaultProps = {
  proformas: [],
  pedidos: [],
};

class TablaPedidos extends Component {
  constructor(props){
    super(props);
    this.state= {
      isOpen:false,
      ValueTab:1,
      solicitudfacturacion:[],
      pedidosAutorizaciones:[],
      selectCodCia:'',
      selectCodProv:'',
      selectPedido:'',
      selectNurPedido:'',
      selectProforma:'',
      rowSelected:'',
      muestraLoad:'none',
      wasExecuteQuery:false
    };
  }

  closeModal = () =>{
    this.setState({isOpen:false});
  }

  openModal = () =>{
    this.setState({isOpen:true});
  }

  cheCkTab = (option) =>  this.setState({ValueTab:option});

  componentDidUpdate(prevProps, prevState) {
    if(prevProps.isFinishedAsignacionDefinitiva) {
      const { selectCodCia,
        selectCodProv,
        selectPedido,
        selectNurPedido,
        selectProforma } = prevState;
      if(selectProforma !== '' && selectPedido !== '') {
        this.getPedidosPedidosAutorizaciones(
          selectProforma,
          selectPedido,
          selectCodCia,
          selectCodProv,
          selectNurPedido
        );
      }
      this.props.doneAsignacionDefinitiva(false);
    }
  }

  toggleRow = (index) => {
    if (index === this.state.rowSelected) {
      this.setState({ rowSelected: '' });
    } else {
      this.setState({ rowSelected: index });
    }
  }

  getPedidosPedidosAutorizaciones = (numProforma,idPedido,codCia,codProv,nurAutFichaVtaVeh) => {
    this.setState({muestraLoad:'block'});
    this.setState({selectCodCia:codCia,
      selectCodProv:codProv,
      selectPedido:idPedido,
      selectNurPedido:nurAutFichaVtaVeh,
      selectProforma:numProforma});
    getPedidosPedidosAutorizaciones(this.props.fdvID,numProforma,codCia,codProv,idPedido,'P').then((result) => {
      this.setState({pedidosAutorizaciones: result.data.actividadesList,
        muestraLoad:'none'});
    }).catch(error => console.log(error));
  }

  fnSelectPedido = (selectPedido) => {
    this.setState({selectPedido:selectPedido,isOpen:true})
  }

  render(){
    let autorizaciones = [];

    autorizaciones = this.state.pedidosAutorizaciones
    if (_.isArray(autorizaciones)) {
      autorizaciones = _.sortBy(autorizaciones, 'numOrdenHito');
      autorizaciones = _.groupBy(autorizaciones, 'codHitoFive');
      autorizaciones = _.toArray(autorizaciones);
    }

    return(
      <div>
        <AutorizacionesHorizontal
            pedidos={this.props.pedidos}
            numProfVeh={this.props.numProforma}
            getPedidosPedidosAutorizaciones={this.getPedidosPedidosAutorizaciones}
            pedidosAutorizaciones={this.state.pedidosAutorizaciones}
            selectCheckPedidos={this.props.selectCheckPedidos}
            pedidosConCheck={this.props.pedidosConCheck}
            loading={this.props.loading}
        />
        <TablePedidos
            pedidos={this.props.pedidos}
            numProfVeh={this.props.numProforma}
            getPedidosPedidosAutorizaciones={this.getPedidosPedidosAutorizaciones}
            pedidosAutorizaciones={this.state.pedidosAutorizaciones}
            selectCheckPedidos={this.props.selectCheckPedidos}
            pedidosConCheck={this.props.pedidosConCheck}
            openModal = {this.openModal}
            loading={this.props.loading}
            selectAll={this.props.selectAll}
            fnSelectPedido = {this.fnSelectPedido}
        />
        {
          this.state.isOpen === true &&
        <PedidoDetalle
            isOpen={this.state.isOpen}
            closeModal = {this.closeModal}
            pedidos={this.props.pedidos.length > 0? this.props.pedidos.filter(entry => entry.numPedidoVeh===this.state.selectPedido)[0] : {}}
        />
        }
      <div className='modal extraFilter' role='dialog' data-backdrop='static' style={{ display: this.state.muestraLoad }} >
          <div className='modal-dialog modal-sm' role='document'>
            <FadeLoader color={'#F8A14A'} loading />
          </div>
        </div>

      </div>
    );
  }
}

  function mapStateToProps(state) {
    return {
      facturacion:state.facturacion
    }
  }

  export default withRouter(
  connect(mapStateToProps, {
    fetchSolicitudesFacturacion
  })(TablaPedidos));



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/DetallePedido/TablaPedidos.js